import { Amplitude } from 'apps/main/libs/analytics/amplitude/data-access-amplitude'
import { useEffectOnce } from '@frontend-mono/shared/util-hook'

export const useEnterRoadmap = () => {
  useEffectOnce(() => {
    Amplitude.logEventByCategory('enter', 'frontend2023_page')
  })
}
